import { MantineThemeOverride } from "@mantine/core"

const theme: MantineThemeOverride = {
	fontFamily: 'Inter, sans-serif', 
	colors: {
		purple: ["#E0E0F5", "#CDCDEF", "#B9B9E8", "#A6A6E2", "#9292DB", "#7F7FD5", "#6C6CC6", "#5959B8", "#4545A9", "#32329A"]
	},
	primaryColor: 'purple',
	colorScheme: 'light'
}

export default theme